import React from 'react';
import { Package, DollarSign, AlertTriangle } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { formatCurrency } from '../../lib/utils';
import { useCanSeeAmounts } from '../../context/PermissionsContext';

export function InventoryStats({ materials, totalsByMaterial, lowStockCount }) {
  const canSeeAmounts = useCanSeeAmounts('inventory');
  return (
    <div className={`grid grid-cols-1 gap-4 ${canSeeAmounts ? 'sm:grid-cols-3' : 'sm:grid-cols-2'}`}>
      <Card className="border-slate-200">
        <CardContent className="p-4 flex items-center gap-4">
          <div className="w-12 h-12 rounded-full bg-[#931A25]/10 flex items-center justify-center">
            <Package className="h-6 w-6 text-[#931A25]" />
          </div>
          <div>
            <p className="text-sm text-slate-500">Total Materiales</p>
            <p className="text-xl font-bold text-slate-900">{materials.length}</p>
          </div>
        </CardContent>
      </Card>
      {canSeeAmounts && (
        <Card className="border-slate-200">
          <CardContent className="p-4 flex items-center gap-4">
            <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center">
              <DollarSign className="h-6 w-6 text-green-600" />
            </div>
            <div>
              <p className="text-sm text-slate-500">Valor Total Inventario</p>
              <div className="space-y-1">
                {totalsByMaterial.DOP > 0 && (
                  <p className="text-lg font-bold text-slate-900">{formatCurrency(totalsByMaterial.DOP, 'DOP')}</p>
                )}
                {totalsByMaterial.USD > 0 && (
                  <p className="text-lg font-bold text-blue-700">{formatCurrency(totalsByMaterial.USD, 'USD')}</p>
                )}
                {!totalsByMaterial.DOP && !totalsByMaterial.USD && (
                  <p className="text-lg font-bold text-slate-900">RD$ 0.00</p>
                )}
              </div>
            </div>
          </CardContent>
        </Card>
      )}
      <Card className="border-slate-200">
        <CardContent className="p-4 flex items-center gap-4">
          <div className={`w-12 h-12 rounded-full flex items-center justify-center ${lowStockCount > 0 ? 'bg-red-100' : 'bg-green-100'}`}>
            <AlertTriangle className={`h-6 w-6 ${lowStockCount > 0 ? 'text-red-600' : 'text-green-600'}`} />
          </div>
          <div>
            <p className="text-sm text-slate-500">Alertas Stock</p>
            <p className="text-xl font-bold text-slate-900">{lowStockCount}</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
